import { render } from "./ChatInputForm.vue?vue&type=template&id=ce10f888&scoped=true"
import script from "./ChatInputForm.vue?vue&type=script&lang=js"
export * from "./ChatInputForm.vue?vue&type=script&lang=js"

import "./ChatInputForm.vue?vue&type=style&index=0&id=ce10f888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce10f888"]])

export default __exports__